import { createSelector } from 'reselect';
import { get } from 'lodash';
import { formValueSelector } from 'redux-form';

import {
  UNCATEGORIZED_RECIPE_CATEGORY,
  ALACARTE_RECIPE_CATEGORY,
  VIEW_BY,
} from 'Pages/managemenu/subpages/editmenu/constants';
import { createMap } from 'Common/Helpers/format';
import { makeOptionsData, makeOptionsDataWithAll } from 'Common/FormHelper';
import {
  PreparationInstructionEnum as PreparationInstructionFields,
  HACCPFieldEnum as HACCPFields,
} from 'Common/FieldEnum';

const root = state => get(state, 'ManageMenuState.common');

export const getSelectedRecipesById = state =>
  get(root(state), 'selectedRecipesById', {});

export const getCopiedRecipesById = state =>
  get(root(state), 'copiedRecipesById', {});

export const getCopiedDays = state => get(root(state), 'copiedDays', {});

export const getRecipeCategories = state =>
  get(root(state), 'recipeCategories', []);

export const getRecipeCategoriesMap = createSelector(
  getRecipeCategories,
  recipeCatgories => createMap(recipeCatgories, 'Id')
);

export const getRecipeCategoryOptions = createSelector(
  getRecipeCategories,
  recipeCategories => makeOptionsData(recipeCategories)
);

export const getRecipesCategoriesWithNull = createSelector(
  getRecipeCategories,
  recipeCategories => recipeCategories.concat(UNCATEGORIZED_RECIPE_CATEGORY)
);

export const getRecipesCategoriesWithALaCarte = createSelector(
  getRecipesCategoriesWithNull,
  recipeCategories => recipeCategories.concat(ALACARTE_RECIPE_CATEGORY)
);

export const getCategoriesForView = (state, view) => {
  return view === VIEW_BY.DAY
    ? getRecipesCategoriesWithNull(state)
    : getRecipesCategoriesWithALaCarte(state);
};

export const getRecipeGroups = state => get(root(state), 'recipeGroups', []);

export const getRecipeGroupsMap = createSelector(
  getRecipeGroups,
  recipeGroups => createMap(recipeGroups, 'Id')
);

export const getRecipeGroupOptions = createSelector(
  getRecipeGroups,
  recipeGroups => makeOptionsDataWithAll(recipeGroups)
);

export const getRecipeSources = state => get(root(state), 'recipeSources', []);
export const getRecipeSourcesMap = createSelector(
  getRecipeSources,
  recipeSources => createMap(recipeSources, 'Id')
);

export const getRecipeHACCP = state => get(root(state), 'recipeHACCP', []);
export const getRecipeHACCPMap = createSelector(getRecipeHACCP, recipeHACCP =>
  createMap(recipeHACCP, 'Id')
);

export const getRecipeServingTemp = state =>
  get(root(state), 'recipeServingTemp', []);

export const getHasFetchedRecipeSubscription = state =>
  !(
    getRecipeCategories(state).length === 0 &&
    getRecipeSources(state).length === 0 &&
    getRecipeGroups(state).length === 0 &&
    getRecipeHACCP(state).length === 0 &&
    getRecipeServingTemp(state).length === 0
  );

export const getHACCPs = state => get(root(state), 'haccps', []);
export const getFilteredHACCPs = createSelector(
  [state => state, (state, formName) => formName, getHACCPs],
  (state, formName, haccps) => {
    const selector = formValueSelector(formName);
    const selectedHACCPTypeId = selector(
      state,
      PreparationInstructionFields.TypeId
    );
    return haccps.filter(
      haccp => haccp[HACCPFields.HACCPTypeId] === selectedHACCPTypeId
    );
  }
);

export const getHACCPsMap = createSelector(getHACCPs, haccps =>
  createMap(haccps, 'Id')
);
export const getHACCPOptions = createSelector(getHACCPs, haccps =>
  makeOptionsData(haccps)
);
export const getFilteredHACCPOptions = createSelector(
  getFilteredHACCPs,
  haccps => makeOptionsData(haccps)
);

export const getHACCPTypes = state => get(root(state), 'haccpTypes', []);
export const getHACCPTypesMap = createSelector(getHACCPTypes, haccpTypes =>
  createMap(haccpTypes, 'Id')
);
export const getHACCPTypeOptions = createSelector(getHACCPTypes, haccpTypes =>
  makeOptionsData(haccpTypes)
);

export const getMealTypes = state => get(root(state), 'mealTypes', []);
export const getMealTypesMap = createSelector(getMealTypes, mealTypes =>
  createMap(mealTypes)
);
export const getMealTypeOptions = createSelector(getMealTypes, mealTypes =>
  makeOptionsData(mealTypes)
);

export const getInstructionDescriptions = state =>
  get(root(state), 'instructionDescriptions', []);
export const getInstructionDescriptionsMap = createSelector(
  getInstructionDescriptions,
  descriptions => createMap(descriptions, 'Id')
);
export const getInstructionDescriptionOptions = createSelector(
  getInstructionDescriptions,
  descriptions => makeOptionsData(descriptions)
);



// WEBPACK FOOTER //
// ./src/pages/managemenu/state/common/selectors.js